import { Component, OnInit, OnDestroy } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators, UntypedFormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { PhotoNotes } from 'src/providers/photo-notes/photo-notes';
import { ToDos } from 'src/providers/to-dos/to-dos';
import { PhotoCaptionService } from 'src/shared/components/photo-caption/photo-caption.service';
import { CameraProvider } from 'src/shared/providers/camera/camera';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';

@Component({
    templateUrl: 'add-room-photo.html',
    providers: [PhotoCaptionService],
    standalone: false
})

export class ToDosAddRoomPhotoPage implements OnInit, OnDestroy {

  caption: string;
  captions: string[] = [];
  card: any;
  errorMessage: string;
  form: UntypedFormGroup;
  formControl = new UntypedFormControl();
  isMultiple: boolean;
  isRightSideContent: boolean;
  loaded = false;
  photoUrls: string[] = [];


  boundRetakeImage = this.retakeImage.bind(this);
  boundSave = this.save.bind(this);

constructor(
    private fb: UntypedFormBuilder,
    private rightSidePanelService: RightSidePanelService,
    private storage: TidyStorage,
    private camera: CameraProvider,
    private photoNotes: PhotoNotes,
    private todos: ToDos,
    private route: ActivatedRoute,
    private navCtrl: CustomNavController,
    private photoCaptionService: PhotoCaptionService,
    private windowService: WindowService
  ) {
    this.form = this.fb.group({
      addresses: ['', Validators.required]
    });
  }

  async ngOnInit() {
    this.loaded = true;
    this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
    const dialogParams = await this.storage.retrieve('dialog-params');
    this.rightSidePanelService.setDialogPageTitle('Add Card Photo');
    this.card = await this.navCtrl.getParam('card') || dialogParams.card;
    this.isMultiple = await this.navCtrl.getParam('multiple') || dialogParams.multiple || false;
    try {
      if (this.isMultiple) {
        this.photoUrls = await this.storage.retrieve('roomPhotoNotes') || [];
      } else {
        const photoUrl = await this.storage.retrieve('roomPhotoNote');
        if (photoUrl) {
          this.photoUrls = [photoUrl];
        }
      }
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async retakeImage() {
    try {
      if (this.isMultiple) {
        const newPhotoNotes = await this.photoCaptionService.getMultipleImages('room');
        this.photoUrls = newPhotoNotes.map(note => note.url);
        await this.storage.delete('roomPhotoNotes');
      } else {
        const newPhotoNote = await this.photoCaptionService.getImg('room');
        this.photoUrls = [newPhotoNote.url];
        await this.storage.delete('roomPhotoNote');
      }
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  async save() {
    try {
      const photoPromises = this.photoUrls.map(async (photoUrl, index) => {
        const awsResp = await this.photoNotes.uploadPictureToS3(photoUrl, this.card.id);
        const caption = this.isMultiple ? (this.captions[index] || null) : (this.caption || null);
        const photo = await this.todos.addGroupPhotoNote(this.card.id, awsResp.Location, caption);
        return photo;
      });

      await Promise.all(photoPromises);
      this.storage.delete('room');
      const dialogParams = await this.storage.retrieve('dialog-params');
      if (dialogParams) {
        dialogParams.room = null;
        await this.storage.save('dialog-params', dialogParams);
      }
      if (this.windowService.isDesktopRes) {
        this.rightSidePanelService.goBack();
        return;
      }
      this.rightSidePanelService.navigateTo('card');
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
    }
  }

  deletePhoto(index: number) {
    this.photoUrls.splice(index, 1);
    this.captions.splice(index, 1);
  }

  async ngOnDestroy() {
    if (this.isMultiple) {
      await this.storage.delete('roomPhotoNotes');
    } else {
      await this.storage.delete('roomPhotoNote');
    }
  }
}
